var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as appTools from "./appTools";
import * as commonFun from "./tools";
import * as share from "./share";
import * as request from "./request";
import smartScroll from "./smartScroll";
import * as bdLog from "./bdLog";
import * as countDown from "./countDown";
import * as dataStorage from "./dataStorage";
import * as form from "./form";
import * as mTracklog from "./mTracklog";
import * as urlMethod from "./urlMethod";
import { addVconsole } from "./vconsole";
import { getAdv } from "./getAdv";
import { lazyloadImg } from "./lazyloadImg";
import * as wbLog from "./wubaLog";
import * as copyText from "./copyText";
import * as getScreenShotInfo from "./getScreenShotInfo";
import { getUploadImg } from "./getUploadImg";
import * as wmdaTracklog from "./wmdaTracklog";
import useCountDown from "./useCountDown";
import * as NewcarCommonApis from "./newcarCommonApis";
import * as AutoHooks from "./autoHooks";
import * as carPurchaseCalculator from "./calculation";
import * as PushState from "./pushState";
import { getExposureDom } from "./getExposureDom";
// import * as EncryptionFn from './crypto'; // 不兼容安卓5
export var tools = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, appTools), commonFun), bdLog), share), request), { smartScroll: smartScroll }), countDown), dataStorage), form), mTracklog), urlMethod), { addVconsole: addVconsole,
    getAdv: getAdv,
    lazyloadImg: lazyloadImg }), wbLog), copyText), getScreenShotInfo), { getUploadImg: getUploadImg }), wmdaTracklog), { useCountDown: useCountDown }), NewcarCommonApis), AutoHooks), carPurchaseCalculator), PushState), { getExposureDom: getExposureDom
    // ...EncryptionFn,
 });
